import { Component, ViewEncapsulation } from '@angular/core';
import {TranslateParser, TranslateService} from 'ng2-translate/ng2-translate';
import {ConfigService} from './services/configuracion/config.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'app works!';

  constructor(private translate: TranslateService, private config: ConfigService) {
    translate.addLangs(config.languages);
    translate.setDefaultLang(config.defaultLanguage);
    translate.use(config.defaultLanguage);
    translate.reloadLang(config.defaultLanguage);
    console.log(config.defaultLanguage, config.languages, translate.getBrowserLang());

  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts